(function () {
  var CLOSE_DELAY = 120;
  var HOVER_MIN_WIDTH = 1300;
  var closeTimer = null;
  var resizeTimer = null;

  function getHeaders() {
    return document.querySelectorAll(
      '.header-ab--v1 .site-header, .header-ab--v2 .site-header, [data-section-type="header-section"] .site-header, [data-section-type="header-section-v2"] .site-header'
    );
  }

  function getHeader() {
    return getHeaders()[0] || null;
  }

  function useHoverMode(header) {
    return (
      header &&
      header.dataset.megaMenuHover !== 'false' &&
      window.innerWidth >= HOVER_MIN_WIDTH
    );
  }

  function getMegaDetails(header) {
    return header ? header.querySelectorAll('.site-nav--has-mega .site-nav__details') : [];
  }

  function syncMegaShell(header) {
    var shell = header.querySelector('.site-nav__mega-shell');
    if (!shell) return;

    var openDetail = header.querySelector('.site-nav__details--mega[open]');
    var panel = openDetail ? openDetail.querySelector('.site-nav__mega') : null;

    if (panel) {
      shell.style.height = panel.offsetHeight + 'px';
    } else {
      shell.style.height = '';
    }
  }

  function setOpen(detail, isOpen) {
    var summary = detail.querySelector('summary');
    var header = detail.closest('.site-header') || getHeader();
    if (isOpen) {
      detail.setAttribute('open', '');
      if (summary) summary.setAttribute('aria-expanded', 'true');
    } else {
      detail.removeAttribute('open');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    }
    if (header) {
      requestAnimationFrame(function () {
        syncMegaShell(header);
      });
    }
  }

  function closeAll(header, except) {
    getMegaDetails(header).forEach(function (detail) {
      if (detail !== except) setOpen(detail, false);
    });
    syncMegaShell(header);
  }

  function clearCloseTimer() {
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
  }

  function scheduleClose(header) {
    clearCloseTimer();
    closeTimer = setTimeout(function () {
      if (!useHoverMode(header)) return;
      if (!header.matches(':hover')) {
        closeAll(header);
      }
    }, CLOSE_DELAY);
  }

  function bindClickMode(header) {
    getMegaDetails(header).forEach(function (detail) {
      var summary = detail.querySelector('summary');
      if (!summary) return;

      summary.addEventListener('click', function (event) {
        if (useHoverMode(header)) {
          // Hover owns open/close at wide widths; keep native toggle from flipping state.
          event.preventDefault();
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        var willOpen = !detail.hasAttribute('open');
        closeAll(header, willOpen ? detail : null);
        setOpen(detail, willOpen);
      });
    });

    document.addEventListener('click', function (event) {
      if (useHoverMode(header)) return;
      if (!header.contains(event.target)) {
        closeAll(header);
      }
    });
  }

  function bindHoverMode(header) {
    getMegaDetails(header).forEach(function (detail) {
      detail.addEventListener('mouseenter', function () {
        if (!useHoverMode(header)) return;
        clearCloseTimer();
        closeAll(header, detail);
        setOpen(detail, true);
      });

      detail.addEventListener('mouseleave', function (event) {
        if (!useHoverMode(header)) return;
        var next = event.relatedTarget;
        if (next && header.contains(next)) return;
        scheduleClose(header);
      });
    });

    header.querySelectorAll('.site-nav__item:not(.site-nav--has-mega)').forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        if (!useHoverMode(header)) return;
        clearCloseTimer();
        closeAll(header);
      });
    });

    header.addEventListener('mouseleave', function (event) {
      if (!useHoverMode(header)) return;
      var next = event.relatedTarget;
      if (next && header.contains(next)) return;
      scheduleClose(header);
    });

    header.addEventListener('mouseenter', function () {
      if (!useHoverMode(header)) return;
      clearCloseTimer();
    });
  }

  function bindOneHeader(header) {
    if (!header || header.dataset.megaMenuBound === 'true') return;
    header.dataset.megaMenuBound = 'true';
    header.dataset.megaMenuWasHover = useHoverMode(header) ? 'true' : 'false';

    bindClickMode(header);
    bindHoverMode(header);

    getMegaDetails(header).forEach(function (detail) {
      detail.addEventListener('toggle', function () {
        syncMegaShell(header);
      });
    });
  }

  function bindMegaMenu() {
    var headers = getHeaders();
    if (!headers.length) return;

    headers.forEach(bindOneHeader);

    if (window.__megaMenuResizeBound) return;
    window.__megaMenuResizeBound = true;

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        getHeaders().forEach(function (header) {
          syncMegaShell(header);
          var isHover = useHoverMode(header);
          var wasHover = header.dataset.megaMenuWasHover === 'true';
          if (isHover !== wasHover) {
            clearCloseTimer();
            closeAll(header);
            header.dataset.megaMenuWasHover = isHover ? 'true' : 'false';
          }
        });
      }, 100);
    });
  }

  function rebind() {
    getHeaders().forEach(function (header) {
      header.dataset.megaMenuBound = '';
    });
    bindMegaMenu();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindMegaMenu);
  } else {
    bindMegaMenu();
  }

  document.addEventListener('shopify:section:load', rebind);
  document.addEventListener('shopify:section:reorder', rebind);
})();
